import React from "react";
import { MdKeyboardArrowRight } from "react-icons/md";

function Projects() {
  return (
    <div className="bg-second py-16 mt-12 text-white ">
      <div className="md:container md:mx-auto">
        <div className="header flex sm:justify-center md:justify-between items-center">
          <h1 className="uppercase font-bold text-2xl inline-block border-b border-white-2">
            layihələr
          </h1>
          <button className="md:flex sm:hidden justify-center rounded-md transition ease-in-out delay-150 b text-white bg-first w-40 px-7 py-3">
            Hamısı
            <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
          </button>
        </div>
        <div className="cards md:flex-nowrap sm:flex-wrap sm:justify-center mt-12 flex gap-8">
          <div className="flex flex-col card relative ">
            <img
              className="w-72 h-80 brightness-50"
              src="https://www.islamicarchitecturalheritage.com/wp-content/uploads/2020/06/maiden-tower-qiz-qalasi.jpg"
              alt=""
            />
            <div className="content  ml-3 flex flex-col mb-4 gap-y-4 absolute bottom-0 left-0">
              <p>Lorem ipsum dolor sit amet consectetur </p>
              <button className="flex text-white">
                Ətraflı
                <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
              </button>
            </div>
          </div>

          <div className="flex flex-col card relative">
            <img
              className="w-72 h-80 brightness-50"
              src="https://bakucity.preslib.az/images/pages/memar_ich12.jpg"
              alt=""
            />
            <div className="content ml-3 flex flex-col mb-4 gap-y-4 absolute bottom-0 left-0">
              <p>Lorem ipsum dolor sit amet consectetur </p>
              <button className="flex text-white ">
                Ətraflı
                <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
              </button>
            </div>
          </div>

          <div className="flex flex-col card relative">
            <img
              className="w-72 h-80 brightness-50"
              src="http://www.azerbaijans.com/uploads/21a.jpg"
              alt=""
            />
            <div className="content ml-3 flex flex-col mb-4 gap-y-4 absolute bottom-0 left-0">
              <p>Lorem ipsum dolor sit amet consectetur </p>
              <button className="flex text-white ">
                Ətraflı
                <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
              </button>
            </div>
          </div>

          <div className="flex flex-col card relative">
            <img
              className="w-72 h-80 brightness-50"
              src="https://portal.azertag.az/sites/default/files/baki2_0.jpg"
              alt=""
            />
            <div className="content ml-3 flex flex-col mb-4 gap-y-4 absolute bottom-0 left-0">
              <p>Lorem ipsum dolor sit amet consectetur </p>
              <button className="flex text-white ">
                Ətraflı
                <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
              </button>
            </div>
          </div>
        </div>
        <button className="md:hidden sm:flex mt-16 mx-auto justify-center rounded-md text-white bg-first w-40 px-7 py-3">
          Hamısı
          <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
        </button>
      </div>
    </div>
  );
}

export default Projects;
